<template>
  <div style="width: 100%;padding-top: 16px; margin-top: 0px;">
    <div class="filtering">
      <div class="search-toggle">
        <p>{{ $t('SearchBy') }}</p>
        <div>
          <p
            class="active"
          >
            {{ $t('VariantName') }}
          </p>
        </div>
      </div>
      <div>
        <div class="black">
          <b-icon-search
            v-if="searchOrder == null"
            class="search"
            style=" position: absolute; left: 5px; top: 13px"
          />
          <b-icon-x-circle
            v-else-if="searchOrder != null && !noSearch"
            class="search"
            style="position: absolute; margin-top: -6px; right: 20px; top: 17px; cursor: pointer"
            @click="clearSearch"
          />
          <input
            v-model="searchOrder"
            type="text"
            autocomplete="off"
            name="search-box"
            :placeholder="$t('VariantName')"
            :style="getMaterialVariantsWithId.length > 0 && noSearch ? 'border-radius: 8px 8px 8px 8px' : ''"
            @keyup="inputChanged"
            @keydown.down="onArrowDown"
            @keydown.up="onArrowUp"
          >
        </div>
        <div
          v-if="getMaterialVariantsWithId.length > 0 && noSearch"
          ref="scrollContainer"
          class="dropdrop"
          :style="getMaterialVariantsWithId.length > 7 ? 'height: 210px' : 'height: auto'"
        >
          <div
            v-for="(result, index) in getMaterialVariantsWithId"
            :key="index"
            ref="options"
            style="cursor: pointer"
            class="search-item"
            :class="{ 'is-active': index === arrowCounter }"
            @click="searchByOn(result);"
          >
            <p style="margin: 0">
              {{ result.materialVariantName }}
            </p>
          </div>
          <!-- <div
            v-if="getFilteredOrdersbyON.length == 0"
            class="search-item"
          >
            <p>Sorry. No Results.</p>
          </div> -->
        </div>
      </div>
    </div>
    <div class="inputs">
      <b-form-group
        :label="$t('EndDate')"
      >
        <date-picker
          v-model="endDate"
          value-type="format"
          :placeholder="$t('SelectD')"
          :format="'YYYY-MM-DD'"
          :clearable="false"
          :lang="lang"
        />
      </b-form-group>
      <b-form-group
        :label="$t('MeasurementType')"
        style="width: 21%;"
      >
        <vue-select
          v-model="measurementType"
          :options="getMeasurementTypes"
          label="measurementName"
          :reduce="(e) => e.value"
          :placeholder="$t('SelectMeasurementType')"
          aria-describedby="input-1-live-feedback"
          :clearable="true"
        />
        <b-form-invalid-feedback
          id="input-1-live-feedback"
        >{{ $t('This_is_a_required_field_and_must_be_at_least_3_letters') }}</b-form-invalid-feedback>
      </b-form-group>
      <b-button
        v-b-tooltip.hover="$t('DownloadExcel')"
        style="border: 0; width: 48px; height: 37px; background: #FF274F; border-radius: 5px; margin-top: 1.3%"
        @click="downloadEXCEL"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="white"
          class="bi bi-file-earmark-spreadsheet"
          viewBox="0 0 16 16"
        >
          <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h3v2H6zm4 0v-2h3v1a1 1 0 0 1-1 1h-2zm3-3h-3v-2h3v2zm-7 0v-2h3v2H6z" />
        </svg>
      </b-button>
    </div>
    <div style="height: 72vh; overflow-y: scroll; margin-top: 15px">
      <table
        ref="exportable_table"
        class="team_table"
      >
        <thead style="position: sticky; top: -2px">
        <tr>
          <th>
            {{ $t('No') }}
          </th>
          <th>
            {{ $t('VariantName') }}
          </th>
          <th>
            {{ $t('Stock') }}
          </th>
          <th>
            {{ $t('LastModifiedDate') }}
          </th>
        </tr>
        </thead>
        <tbody v-if="getMaterialVariantsStock.length > 0">
        <tr
          v-for="(material, index) in getMaterialVariantsStock"
          :key="index"
        >
          <td>
            {{ getTotalItemsMaterialBalance - (page - 1) * pageSize - index }}.
          </td>
          <td>{{ material.materialVariantName }}</td>
          <td>{{ material.balanceStock }}</td>
          <td>{{ formatDateTime(material.lastModifiedTime) }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td>{{ $t('NoStockOverviewData') }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div>
      <b-pagination
        v-if="getTotalItemsMaterialBalance > 15"
        v-model="page"
        :total-rows="getTotalItemsMaterialBalance"
        :per-page="pageSize"
        first-number
        last-number
        align="fill"
        prev-class="prev-itemi"
        next-class="next-itemi"
        class="mt-1 mb-0"
      >
        <template #prev-text>
          <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
        </template>
        <template #next-text>
          <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
        </template>
      </b-pagination>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

export default {
  name: 'StockOverview',
  components: {
    DatePicker,
  },
  data() {
    return {
      pageNumber: 1,
      pageSize: 15,
      endDate: moment()
        .format('YYYY-MM-DD'),
      measurementType: null,
      page: 1,
      searchOrder: null,
      noSearch: false,
      arrowCounter: 0,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      'getMaterialVariantsStock',
      'getTotalItemsMaterialBalance',
      'getTotalPagesMaterialBalance',
      'getMaterialVariantsWithId'
      ],
    ),
    getMeasurementTypes() {
      return [
        { measurementName: this.$t('Package'), value: 'Package' },
        { measurementName: this.$t('Set'), value: 'Set' },
        { measurementName: this.$t('Meter'), value: 'Meter' },
        { measurementName: this.$t('Pair'), value: 'Pair' },
        { measurementName: this.$t('Beaded strand'), value: 'Verse' },
        { measurementName: this.$t('Part'), value: 'Part' },
      ];
    },
  },
  watch: {
    endDate(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.loadMaterialBalanceStock({
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          endDate: this.endDate,
          materialVariantId: this.searchOrder,
          measurementType: this.measurementType || 'ALL'
        });
      }
    },
    measurementType(newVal, oldVal) {
      const type = newVal || 'ALL';
      this.loadMaterialBalanceStock({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        endDate: this.endDate,
        materialVariantId: this.searchOrder,
        measurementType: type
      });
    },
    page(value) {
      if (this.searchOrder != null) {
        this.loadMaterialBalanceStock({
          pageNumber: value,
          pageSize: this.pageSize,
          endDate: this.endDate,
          materialVariantId: this.searchOrder,
          measurementType: this.measurementType || 'ALL'
        })
      } else {
        this.loadMaterialBalanceStock({
          pageNumber: value,
          pageSize: this.pageSize,
          endDate: this.endDate,
          materialVariantId: this.searchOrder,
          measurementType: this.measurementType || 'ALL'
        })
      }
    },
    searchOrder(newVal) {
      if (newVal && newVal.length >= 2) {
        this.loadMaterialVariantWithId(this.searchOrder)
      } else {
        this.noSearch = true
      }
    },
  },
  mounted() {
    this.loadMaterialBalanceStock({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      endDate: this.endDate,
      materialVariantId: this.searchOrder,
      measurementType: this.measurementType || 'ALL'
    })
  },
  methods: {
    ...mapActions(['loadMaterialBalanceStock', 'resetMaterialVariantWithId', 'loadMaterialVariantWithId']),
    formatDateTime(date) {
      return moment(date)
        .format('YYYY-MM-DD');
    },
    async clearSearch() {
      this.searchOrder = null;
      this.noSearch = false;
      this.resetMaterialVariantWithId();
      await this.loadMaterialBalanceStock({
        pageNumber: this.page,
        pageSize: this.pageSize,
        endDate: this.endDate,
        materialVariantId: this.searchOrder,
        measurementType: this.measurementType || 'ALL'
      })
    },
    async searchByOn(value) {
      this.searchOrder = value.materialVariantName
      this.noSearch = false
      await this.loadMaterialBalanceStock({
        pageNumber: this.page,
        pageSize: this.pageSize,
        endDate: this.endDate,
        materialVariantId: value.materialVariantId,
        measurementType: this.measurementType || 'ALL'
      })
      this.noSearch = false
      this.noSearch = false
    },
    removeLists() {
      this.noSearch = false;
      this.resetMaterialVariantWithId();
    },
    inputChanged(event) {
      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') { return; }

      // eslint-disable-next-line no-useless-return
      if (event.code === 'Enter') {
        this.enterPressed = true
        this.searchByOn(this.getMaterialVariantsWithId[this.arrowCounter])
        this.removeLists()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
    onArrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getMaterialVariantsWithId.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    downloadPage(pageNumber) {
      return this.loadMaterialBalanceStock({
        pageNumber: pageNumber,
        pageSize: 50,
        endDate: this.endDate,
        materialVariantId: this.searchOrder,
        measurementType: this.measurementType || 'ALL'
      })
        .then(() => {
          return this.generateTableContentCSV(this.getMaterialVariantsStock);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },

    generateTableContentCSV(data) {
      const headers = [
        `${this.$t('VariantName')}`,
        `${this.$t('Stock')}`,
        `${this.$t('LastModifiedDate')}`,
      ];
      const body = data.map((value) => {
        return [
          value.materialVariantName,
          value.balanceStock,
          this.formatDateTime(value.lastModifiedTime),
        ];
      });
      return {
        headers,
        body
      };
    },
    generateExcel(tableContent) {
      const {
        headers,
        body
      } = tableContent;
      const sheetData = [headers, ...body];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      const excelData = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      return excelData;
    },
    downloadEXCEL() {
      this.loadMaterialBalanceStock({
        pageNumber: this.pageNumber,
        pageSize: 50,
        endDate: this.endDate,
        materialVariantId: this.searchOrder,
        measurementType: this.measurementType || 'ALL'
      })
        .then(() => {
          const tableContent = this.generateTableContentCSV(this.getMaterialVariantsStock);

          const totalPages = this.getTotalPagesMaterialBalance;
          const additionalPromises = [];

          for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
            additionalPromises.push(this.downloadPage(pageNumber));
          }

          return Promise.all(additionalPromises)
            .then((additionalTableContents) => {
              additionalTableContents.forEach((additionalTableContent) => {
                tableContent.body = tableContent.body.concat(additionalTableContent.body);
              });

              const excelData = this.generateExcel(tableContent);
              FileSaver.saveAs(excelData, 'StockOverview.xlsx');
            });
        })
        .catch((error) => {
          console.error('Error downloading the Excel file:', error);
        });
    },
  }
}
</script>

<style scoped lang="scss">
.inputs {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: baseline;
}

.team_table td {
  padding: 16px 9px !important;
}

.active{
  color: $base-color;
  font-weight: bold;
  cursor: default;
}

.dropdrop::-webkit-scrollbar {
  display: none;
}

.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: none;
}

input[name="search-box"] {
  display: block;
  max-width: 400px;
  min-width: 275px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}

.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 400;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}

.search-item:last-child {
  border-bottom: none;
}

.search-item:hover {
  background: #82868c;
  color: white;
}

.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}
.is-active {
  background-color: #dedede;
}
</style>
